import React from 'react'
import styled, { css } from 'styled-components'
export const ContainerStyled = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 20px;

  ${({ bgimage }) => bgimage && css`
    background-repeat: no-repeat, repeat;
    background-size: cover;
    object-fit: cover;
    background-position: center;
  `}

  @media (min-width: 768px) {
    padding: 30px 20px;
  }
`

export const Container = (props) => {
  return (
    <ContainerStyled
       {...props}
      style={{ backgroundImage: `url(${props.bgimage})` }}
    >
      {props.children}
    </ContainerStyled>
  )
}

export const InnerContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;


  @media (min-width: 993px) {
    flex-direction: row;
  }
`
export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
  padding-top: 55px;
  @media (min-width: 768px) {
    padding-top: 77px;
  }
`
export const MapWrapper = styled.div`
  position: absolute;
  top: 0px;
  width: 250px;

  img {
    width: 100%;
  }

  @media (min-width: 768px) {
    width: 350px;
  }
`
export const RightContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 20px;

  @media (min-width: 993px) {
    margin-top: 0;
    margin-bottom: 0;
    justify-content: center;
  }
`
export const CardContainer = styled.div`
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0px 4px 10px rgba(120, 16, 116, 0.25);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  position: relative;

  @media (min-width: 768px) {
    padding: 40px 25px;
  }
  @media (min-width: 1200px) {
    padding: 50px 30px;
  }
`
export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 40px;
  > p {
    font-size: 32px;
    line-height: 40px;
    margin: 0;
    white-space: nowrap;
    &:first-child {
      font-weight: 700;
      span {
        font-weight: 400;
      }
    }
    &:last-child {
      font-style: italic;
      font-weight: 700;
    }
  }

  @media (min-width: 768px) {
    > p {
      line-height: 50px;
      font-size: 42px;
    }
  }
`
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    /* max-width: 440px; */
    text-shadow: 0px 8px 6px rgb(0 0 0 / 25%);
    font-size: 12px;
    text-align: center;
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 100;

    &.content-title {
      font-weight: 700;
      font-size: 14px;
    }

    &.head-line {
      font-weight: 700;
      font-size: 16px;
    }
    &.bold {
      font-weight: 700;
    }
    > span {
      font-weight: 700;
    }
  }
  @media (min-width: 768px) {
    > p {
      font-size: 12px;
      margin-bottom: 10px;
      &.content-title {
        font-size: 14px;
      }

      &.head-line {
        font-size: 20px;
      }
    }
  }
`
export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;

  > p {
    margin: 3px 0;
    font-size: 18px;
    text-align: center;

    span {
      font-weight: 700;
    }
  }

  @media (min-width: 768px) {
    > p {
      font-size: 24px;
    }
  }
  @media (min-width: 1200px) {
    > p {
      font-size: 28px;
    }
  }
`
export const BlueBottomBar = styled.div`
  height: 10px;
  width: 30%;
  background: #0F85F1;
  position: absolute;
  bottom: 0;

  @media (min-width: 768px) {
    height: 15px;
  }
`
export const AvailableContainer = styled.fieldset`
  border-left: 1px solid #FFF;
  border-right: 1px solid #FFF;
  border-top: 1px solid #FFF;
  border-bottom: none;
  border-radius: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 40px;
  width: 100%;

  legend {
    padding: 0 10px;
    font-size: 20px;
    font-style: italic;
  }

  .distance {
    font-weight: 700;
    font-size: 62px;
    margin: 0;
    span {
      font-size: 42px;
    }
  }

  div.left {
    display: flex;
    align-items: center;
    width: 100%;

    div {
      background: #FFF;
      height: 1px;
      flex: 1;
    }

    span {
      border: 1px solid #FFF;
      border-radius: 20px;
      font-size: 18px;
      padding: 3px 25px;
    }
  }

  .number {
    font-size: 32px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  div.bottom {
    width: calc(100% - 20px);
    position: absolute;
    bottom: -9px;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      background: rgba(255, 255, 255, 0.6);
      height: 1px;
      flex: 1;
    }
    span {
      margin: 0 10px;
      font-size: 14px;
      font-weight: 700;
      font-style: italic;
    }
  }

  @media (min-width: 768px) {
    width: initial;
    padding: 20px 40px;
    .distance {
      font-size: 92px;
    }
    .number {
      font-size: 52px;
    }
    div.bottom {
      span {
        font-size: 16px;
      }
    }
  }
`
export const ProgressBarContainer = styled.div`
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(120, 16, 116, 0.25);
  padding: 5px;
  width: 80%;
  margin-top: 100px;
  margin-bottom: 50px;

  @media (min-width: 768px) {
    width: 450px;
  }
`

export const ProgressBarContent = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`

export const ProgressPercent = styled.div`
  background: linear-gradient(90deg, #0085FF 6.25%, #00E0FF 142.5%);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  height: 15px;
  position: relative;
`

export const PointWrapper = styled.div`
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #FFFFFF;
  right: 5px;
  top: 5px;
`

export const PointContent = styled.div`
  position: relative;
`

export const TooltipWrapper = styled.div`
  position: absolute;
  left: 0px;
  bottom: 10px;
  border: 1px solid white;
  font-size: 12px;
  transform: translate(-50%, -50%);
  border-radius: 50px;
`

export const TooltipContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 50px;
  background-color: #c2bf4c;
  color: white;
  > span {
    margin: 0px 5px;
    white-space: nowrap;
    &.bold {
      font-weight: bold;
    }
  }
  &::after {
    content: ' ';
    position: absolute;
    left: calc(50% - 6px);
    bottom: -7px;
    width: 12px;
    height: 12px;
    background-color: #c2bf4c;
    border-top: 1px solid white;
    border-left: 1px solid white;
    border-bottom: none;
    border-right: none;
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
  }

  @media (min-width: 993px) {
    background-color: #6e967b;
    &::after {
      background-color: #6e967b;
    }
  }
`
export const InputWrapper = styled.div`
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
  width: 300px;
  margin-bottom: 30px;
  input {
    width: 100%;
    outline: none;
    background: transparent;
    border: 1px solid #FFF;
    border-radius: 10px;
    padding: 20px 25px;
    font-size: 16px;
    font-weight: 500;
    color: #FFF;
  
    &::placeholder,
    &::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
    &:-ms-input-placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }
`
export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;

  p {
    font-size: 14px;
    margin: 5px;
    font-weight: 100;
    color: rgba(255, 255, 255, 0.8);
    span {
      color: #FFF;
      font-weight: 700;
    }
  }
`
export const CustomButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  background: linear-gradient(90deg, #0286FF 6.25%, #025FB6 68.7%);
  border-radius: 10px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 25px;
  width: 280px;

  &:hover {
    background: linear-gradient(90deg,#0366c1 6.25%,#03519b 68.7%);
  }

  &:active {
    background: linear-gradient(90deg,#0358a7 6.25%,#034381 68.7%);
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    object-fit: cover;
  }

  span {
    font-size: 24px;
    font-weight: 600;
  }

  ${({ isSmall }) => isSmall && css`
    padding: 10px 25px;
    width: 150px;

    span {
      font-size: 14px;
    }
  `}

  @media (min-width: 768px) {
    width: 350px;
    ${({ isSmall }) => isSmall && css`
      width: 200px;
    `}
  }
`
